import * as React from 'react'

const getServerSnapshot = () => false

/** Reactive `window.matchMedia` — re-renders when `query` starts/stops matching. */
export function useMatchMedia(query: string): boolean {
  const subscribe = React.useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(query)
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    },
    [query],
  )
  return React.useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    getServerSnapshot,
  )
}
